import React from 'react'

const RightArrowIcon = ({ color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10 17L15 12L10 7V17Z" fill={color || '#3249D7'} />
    </svg>
  )
}

export default RightArrowIcon
